module.exports = "/images/vendor/flag-icon-css/flags/1x1/nr.svg?2ef5b7c8f28f9c85d7c2da25b825ba5f";